import { useEffect, useState } from "react";
import Navbar from "../components/Navbar";
import Hero from "../components/Hero";
import About from "../components/About";
import Experience from "../components/Experience";
import Expertise from "../components/Expertise";
import Services from "../components/Services";
import Impact from "../components/Impact";
import Certifications from "../components/Certifications";
import Blog from "../components/Blog";
import Contact from "../components/Contact";
import Footer from "../components/Footer";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export default function Home() {
  const [blogPosts, setBlogPosts] = useState([]);

  useEffect(() => {
    fetch(`${BACKEND_URL}/api/blog?published_only=true`)
      .then((r) => r.json())
      .then(setBlogPosts)
      .catch(() => {});
  }, []);

  // Scroll reveal
  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("visible");
          }
        });
      },
      { threshold: 0.1, rootMargin: "-40px" }
    );
    document.querySelectorAll(".section-reveal").forEach((el) => observer.observe(el));
    return () => observer.disconnect();
  }, []);

  return (
    <div className="min-h-screen bg-[#F9FAFB]" data-testid="home-page">
      <Navbar />
      <Hero />
      <div className="section-reveal"><About /></div>
      <div className="section-reveal"><Experience /></div>
      <div className="section-reveal"><Expertise /></div>
      <div className="section-reveal"><Services /></div>
      <div className="section-reveal"><Impact /></div>
      <div className="section-reveal"><Certifications /></div>
      <div className="section-reveal"><Blog posts={blogPosts} /></div>
      <div className="section-reveal"><Contact /></div>
      <Footer />
    </div>
  );
}
